import axios from 'axios';
import { clearAuthData } from './auth';

const REDIRECT_API_URL = import.meta.env.VITE_REDIRECT_API_URL || 'https://redirect.rocketgroup.io';

const redirectClient = axios.create({
    baseURL: `${REDIRECT_API_URL}/api/v1`,
    headers: {
        'Content-Type': 'application/json',
    },
});

redirectClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

redirectClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default redirectClient;
export const REDIRECT_PUBLIC_URL = REDIRECT_API_URL;
